<h3 *ngIf="program" class="title-header">
  <mat-icon>view_stream</mat-icon>
  {{program.name}}
</h3>
<mat-tab-group mat-align-tabs="center">
  <mat-tab label="Home">
    <ng-template matTabContent>
      <app-program-edit *ngIf="program" [program]="program"></app-program-edit>
    </ng-template>
  </mat-tab>
  <mat-tab label="Dispatches">
    <ng-template matTabContent>
      <app-program-dispatches *ngIf="program" [program]="program" ></app-program-dispatches>
    </ng-template>
  </mat-tab>
  <mat-tab label="Dispatch Monitoring">
    <ng-template matTabContent>
      <app-dispatch-monitoring *ngIf="program" [program]="program"></app-dispatch-monitoring>
    </ng-template>
  </mat-tab>
</mat-tab-group>





